// extracted by mini-css-extract-plugin
export var card = "_r3-0";
export var content = "_r3-2";
export var details = "_r3-3";
export var icon = "_r3-1";
export var iconBlue = "_r3-5";
export var iconBrand = "_r3-4";
export var iconGrayBlue = "_r3-6";
export var iconGreen = "_r3-7";
export var iconIndigo = "_r3-8";
export var iconOrange = "_r3-9";
export var iconPurple = "_r3-a";
export var iconRed = "_r3-b";
export var iconWarning = "_r3-c";